import React from 'react';
import { Link } from 'react-router-dom';

export default class ServiceThree extends React.Component {
    render() {
        let publicUrl = process.env.PUBLIC_URL + '/'
        return (
            <>
                <section className="services-three">
                    <div className="shape1">
                        <img src={publicUrl + "assets/images/shapes/services-v3-shape1.png"} alt="#" />
                    </div>
                    <div className="shape2 rotate-me">
                        <img src={publicUrl + "assets/images/update1.0/services-v3-shape2.png"} alt="#" />
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="services-three__top">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <h6>COMPANY SERVICES </h6> <span className="right"></span>
                                        </div>
                                        <h2 className="sec-title__title">Our Marine Services</h2>
                                    </div>
                                    <div className="text-box">
                                        <p>
                                            We specialize in marine machinery, navigation systems, ship automation, 
                                            and safety solutions — ensuring reliable and secure operations for vessels worldwide.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {/* Marine Machinery */}
                            <div className="col-xl-3 col-lg-6 col-md-6">
                                <div className="services-three__single active">
                                    <div className="services-three__single__bg"
                                        style={{ backgroundImage: 'url(' + publicUrl + 'assets/images/services/ship-bridge.jpg)' }}>
                                    </div>
                                    <div className="services-three__single-icon">
                                        <i className="fas fa-ship fa-3x"></i> 
                                    </div>
                                    <h3>
                                        <Link to={process.env.PUBLIC_URL + `/services/machinery`}>
                                            Marine Machinery
                                        </Link>
                                    </h3>
                                    <p>
                                        Supply of compressors, pumps, and purifiers —
                                        genuine parts for reliable performance.
                                    </p>
                                    <div className="btn-box">
                                        <Link to={process.env.PUBLIC_URL + `/services/machinery`}>
                                            <span className="icon-right-arrow"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Navigation Systems */}
                            <div className="col-xl-3 col-lg-6 col-md-6">
                                <div className="services-three__single">
                                    <div className="services-three__single__bg"
                                        style={{ backgroundImage: 'url(' + publicUrl + 'assets/images/services/ship-bridge.jpg)' }}>
                                    </div>
                                    <div className="services-three__single-icon">
                                        <i className="fas fa-compass fa-3x"></i> 
                                    </div>
                                    <h3>
                                        <Link to={process.env.PUBLIC_URL + `/services/navigation`}>
                                            Navigation Systems
                                        </Link>
                                    </h3>
                                    <p>
                                        Radar, GPS, ECDIS, and bridge equipment for safe and
                                        accurate vessel navigation.
                                    </p>
                                    <div className="btn-box">
                                        <Link to={process.env.PUBLIC_URL + `/services/navigation`}>
                                            <span className="icon-right-arrow"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Ship Automation */}
                            <div className="col-xl-3 col-lg-6 col-md-6">
                                <div className="services-three__single">
                                    <div className="services-three__single__bg"
                                        style={{ backgroundImage: 'url(' + publicUrl + 'assets/images/services/ship-bridge.jpg)' }}>
                                    </div>
                                    <div className="services-three__single-icon">
                                        <i className="fas fa-cogs fa-3x"></i>
                                    </div>
                                    <h3>
                                        <Link to={process.env.PUBLIC_URL + `/services/automation`}>
                                            Ship Automation
                                        </Link>
                                    </h3>
                                    <p>
                                        Monitoring, alarm, and control systems to boost
                                        efficiency and operational safety.
                                    </p>
                                    <div className="btn-box">
                                        <Link to={process.env.PUBLIC_URL + `/services/automation`}>
                                            <span className="icon-right-arrow"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Marine Safety */}
                            <div className="col-xl-3 col-lg-6 col-md-6">
                                <div className="services-three__single">
                                    <div className="services-three__single__bg"
                                        style={{ backgroundImage: 'url(' + publicUrl + 'assets/images/services/ship-bridge.jpg)' }}>
                                    </div>
                                    <div className="services-three__single-icon">
                                        <i className="fas fa-life-ring fa-3x"></i>
                                    </div>
                                    <h3>
                                        <Link to={process.env.PUBLIC_URL + `/services/safety`}>
                                            Marine Safety
                                        </Link>
                                    </h3>
                                    <p>
                                        Fire detection, gas alarms, and lifesaving gear for
                                        maximum safety at sea.
                                    </p>
                                    <div className="btn-box">
                                        <Link to={process.env.PUBLIC_URL + `/services/safety`}>
                                            <span className="icon-right-arrow"></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
